import React from "react";
import { useSelector, useDispatch } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { setReportCorporateShipmentsFilters, getReportCorporateShipmentsAction } from "redux/actions/Reports/reportCorporateShipments/reportCorporateShipmentsActions";

export const ReportCorporateShipmentsView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportCorporateShipments }) => reportCorporateShipments);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportCorporateShipmentsAction({ startDate, endDate, station }));
  };

  const handleExcel = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportCorporateShipmentsAction({ startDate, endDate, station, isPdf: false }));
  };

  return (
    <GlobalBox title="Reporte de Embarque Corporativo" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingReportCorporateShipments ? <LoadingComponent /> :
        <TableInputs
          reducer="reportCorporateShipments"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportCorporateShipmentsFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={handleExcel}
        />
      }
    </GlobalBox>
  );
};
